const setBodyStyles = (styles: any): void => {
    Object.entries(styles).forEach(([key, value]) => {
        // ts ignore is used as an error is caused using key as it's ont a number
        // @ts-ignore
        document.body.style[key] = value;
    });
};

export { setBodyStyles };
